export var API_FIELD = {
    EntityType: 'CompanyCode',
    LegalRegisteredName: 'LegalRegName',
    DbaName: 'DBAName',
    CustomerCountry: 'CustCountry',
    CustomerState: 'CustState',
    DateBusinessIncorporated: 'BusinessIncorporatedDate',
    TaxpayerId: 'SSN',
    GrossRevenue: 'GrossRevenue',
    TaxExempt: 'TaxExempt',
    VeteranStatus: 'VeteranStatus',
    FirstName: 'FirstName',
    MiddleName: 'MiddleName',
    LastName: 'LastName',
    Suffix: 'Suffix',
    Title: 'Title',
    BusinessTitle: 'BusinessTitle',
    BusinessName: 'BusinessName',
    DateOfBirth: 'DOB',
    OwnershipPercentage: 'OwnershipPercentage',
    Address: 'Address',
    Country: 'Country',
    City: 'City',
    State: 'State',
    PostalCode: 'PostalCode',
    Email: 'Email',
    PhoneNumber: 'PhoneNumber',
    MobilePhone: 'MobilePhone',
    BillingAddress: 'BillingAddress',
    BillingCountry: 'BillingCountry',
    BillingCity: 'BillingCity',
    BillingState: 'BillingState',
    BillingPostalCode: 'BillingPostalCode',
    BillingEmail: 'BillingEmail',
    BillingPhoneNumber: 'BillingPhoneNumber',
    Quantity: 'Quantity',
    Year: 'Year',
    DownPayment: 'DownPayment',
    DocFee: 'DocFee',
    SoftCost: 'SoftCost',
    AssetSoftCost: 'AssetSoftCost',
    EquipmentCost: 'EquipmentCost',
    TotalAssetCost: 'TotalAssetCost',
    TotalAmountFinanced: 'TotalAmountFinanced',
};
export var BILLING_API_PREFIX = 'Billing';
